import React,{useEffect} from 'react';
import { makeStyles, withStyles,useTheme } from '@material-ui/core/styles';
import { withRouter,useHistory,NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat,amountFormatOnly, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
  } from 'mui-rff';
  import {
    Typography,
    Paper,
    Link,
    Grid,
    Button,
    Card,
    Dialog,
    CardActions,
    CardContent,
    CssBaseline,
    MenuItem,
    InputAdornment,
    InputLabel,
    FormControl,
    CardHeader,
    TextField as TextInput,
    Checkbox,
    Box,
    Tabs,
    Tab,
    MobileStepper
  } from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
    getTripDetailsV3,
    updateTripStatus
} from "../../../store/actions/tripActionCreator";
import {sendError, sendSucces,isFunction} from "../../../utils/utils"
import inputStyles from '../css/inputs'
import {
    TRIP_STATUS,
    TRIP_DISPLAY_STATUS,
    TRIP_ACTIONS,
    TRIP_STATUS_DIALOG_TITLES,
    TRIP_STATUS_DIALOG_LABELS,
    PAYMENT_CHIPS,
    TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import S3Uploader from '../s3Uploader/s3Uploader';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import DeleteIcon from '@material-ui/icons/Delete';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const tutorialSteps = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  }
];
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    height: 50,
    width:'100%',
    //paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    marginBottom:24
  },
  img: {
   // height: 255,
    height:'auto',
    display: 'block',
    //maxWidth: 400,
    overflow: 'hidden',
    width: '100%',
  },
  thumb: {
    height:'40px',
    width: '40px',
    margin:'0px 16px',
    borderRadius:4
  }
}));
const ImageViewDialog = (props) => {
    const classes = useStyles();
    const inputClasses = inputStyles();
    let submit
    const { 
        user, 
        onConfirm, 
        open, 
        onClose, 
        onSave,
        action,
        defaultPerson,
        location,
        images,
        active,
        deleteEnable,
        onDelete,
        label,
        thumb,
        journey,
        updateJourney,
        selectedTrip,
        header,
        ...other 
    } = props;
    let path = location && location.pathname ? location.pathname.split("/") : [];
  
    useEffect(() => {
       
    }, []);
    const [dialogopen, setDialogOpen] = React.useState(open);
    const handleFormSave = (e) => {
    }
    const handleClose = (status) => {
        onClose(false);
    };
    const handleConfirm= (status) => {
      onConfirm(false);
    };
    const getFormFields = (values)=>{
        let commonFields = [];
        return commonFields;
    }
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(active?active:0);
    const [steps, setSteps] = React.useState(images?images.filter((img)=>img && img.imgPath != null):[]);
    const maxSteps = images?images.filter((img)=>img && img.imgPath != null).length:0;

    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
      setActiveStep(step);
    };
    const clickDelete = ()=>{
      if(isFunction(onDelete)){
        onDelete(steps[activeStep])
      }
    }
    return (
        <div>
            <Dialog 
                fullWidth={true}
                //maxWidth='auto'
                onClose={handleClose} 
                disableEscapeKeyDown={true} 
                disableBackdropClick={true} 
                aria-labelledby={"Image-Viewer"}
                open={dialogopen}
            >
                <DialogTitle id={"Image-Viewer"} onClose={handleClose}>
                {header?header:'View Images'}
                </DialogTitle>
                <TripActionDialogContent dividers>
                <div className={classes.root}>
                  {!thumb && <MobileStepper
                      steps={maxSteps}
                      position="static"
                      variant="text"
                      activeStep={activeStep}
                      nextButton={
                        !thumb && <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                           Next
                          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                        </Button>
                      }
                      backButton={
                        !thumb && <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                          Back
                        </Button>
                      }
                    />}
                    {thumb&&<Box display={'flex'} alignItems={'center'} marginBottom={'12px'} justifyContent={'center'}>
                              <Typography style={{fontSize:14,fontWeight:600,color:'#3e3f42'}}>{`${activeStep+1}/${maxSteps}`}</Typography>
                      </Box>}
                    <Paper square elevation={0} className={classes.header}>
                      <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                          {!thumb && 'Back'}
                      </Button>
                      {!thumb && <Typography>{steps[activeStep] && steps[activeStep].label}</Typography>}
                      {thumb && steps && steps.map((step, index) => {
                        return <img className={classes.thumb} style={activeStep ===index?{border:'3px solid #5b6bff'}:{}} src={step.imgPath} alt={step.label} />
                      })}
                      <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                          {!thumb && 'Next'}
                          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                      </Button>
                    </Paper>
                    {deleteEnable && <Box  display={'flex'} alignItems={'center'} marginBottom={'12px'} justifyContent={'end'}>
                          <Box onClick={clickDelete} style={{padding:8,border:'solid 1px #de1c22',borderRadius:4,color:'#de1c22',cursor:'pointer'}}><DeleteIcon style={{fontSize:20}} /></Box>
                    </Box>}
                    <div>
                      {/* <div>
                      <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                          Back
                        </Button>
                      </div> */}
                      <div>
                        <SwipeableViews
                          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                          index={activeStep}
                          onChangeIndex={handleStepChange}
                          enableMouseEvents
                        >
                          {steps.map((step, index) => (
                            <div key={step.label}>
                              {Math.abs(activeStep - index) <= 2 ? (
                                <img className={classes.img} src={step.imgPath} alt={step.label} />
                              ) : null}
                            </div>
                          ))}
                        </SwipeableViews>
                      </div>
                      {/* <div>
                      <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                          Next
                          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                        </Button>
                      </div> */}
                    </div>
                  </div>
                </TripActionDialogContent>
                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                    <a style={{ color: "#fff" }} href={steps[activeStep] && steps[activeStep].imgPath} target="_blank" download>
                      <Button variant="contained" className='modal-save-cta'>
                          Download
                      </Button>
                    </a>
                </DialogActions>
            </Dialog>
        </div>
    );
}
const ImageViewDialogWithRouter = withRouter(ImageViewDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageViewDialogWithRouter);